import { DataGrid } from "components/DataGrid/DataGrid";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { Toast } from "components/ToastShow/ToastAlert";
import { useEffect, useState } from "react";
import { trans } from "utils/helpers";
import { getInvitedPeopleListById } from "./api";
import { MessageType } from "types/enum";
import { Button } from "components/Button/Button";
import { sendAttendeesList } from "../AttendeesPeople/api";


export const InvitedPeopleList = ({meetingId,step=1 ,onHide,mode,JobId  }: any) => {

    const [loading, setLoading] = useState(false);
    const [messageType, setMessageType] = useState<any>("info");
    const [response, setResponse] = useState<Response | any>(null);
    const [selectedId, setSelectedId] = useState<string | any>(null);
    const [showActionForm, setShowActionForm] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(false);
    const [filterlist, setFilterlist] = useState<any>("");
    const [orderBy, setOrderBy] = useState<any>([]);
    const [search, setSearch] = useState(null);
    const [resetMultiSelect , setResetMultiSelect] = useState<any>(false)                                    
    const [selectList , setSelectList] = useState<any>([])



    const selectedIdCallback = (obj, index) => {
        if(sessionStorage.getItem("changingforms")+""=="true" && showActionForm){
            // Toast(trans("modalclosemessage"),"warning","alert", ()=>{setSelectedId(obj.Id) ;sessionStorage.setItem("changingforms" , "false");});
            Toast(trans("modalclosemessage"),MessageType.confirm, ()=>{setSelectedId(obj.Id) ;sessionStorage.setItem("changingforms" , "false");});

        }else{
            setSelectedId(obj.Id);
        };
    }

 
    async function getInvitedPeopleListAsync() {
        setLoading(false)
        try {
            const res = await getInvitedPeopleListById( search ,JobId?JobId :meetingId);     
            setResponse(res);    
            setMessageType("info")
        } catch (error) {
            setMessageType("error")
        }
  
        setLoading(true)
    }
    useEffect(() => {
    getInvitedPeopleListAsync()
    setResetMultiSelect(!resetMultiSelect)
    }, [ forceUpdate ,filterlist,search ]);

      const assignedselectListCallBack =(list)=>{
          setSelectList(list[1])
     
    
      }

    async function sendAttendeesListAsync(type) {

        try {   
        const res = await sendAttendeesList(meetingId ,selectList?.map(item=>item?.PositionId),type);
        setForceUpdate(!forceUpdate)
        onHide(false)
        } catch (error) {
            
        }

            
  }
 



    return (
        <>
            <div className="cartable-action">
                {loading ?
                    (response?.Data.length > 0 ?
                        <div className="card ">
                            <div className="p-0">
                                <>
                                    <DataGrid
                                        handlefiltering={(str)=>{setFilterlist(str)}}
                                        filterStr={filterlist}
                                        orderFormat={setOrderBy}
                                        orderFormatList={orderBy}
                                        parentName={"InvitedPeopleList"}
                                        theadData={Object.keys(response?.Data[0])}
                                        tbodyData={response?.Data}
                                        minCellWidth={80}
                                        startIndex={4}
                                        multiSelect={step==4}
                                        selectList={assignedselectListCallBack}
                                        selectedRowObjectCallback={selectedIdCallback}         
                                        resetMultiSelect={resetMultiSelect}
                               
                                    />
                                </>
                            </div>
                        </div>
                        : <Message message={"NoDataForPreview"} type={messageType} />
                    )
                    : <Loading />
                }
{
    step==4 &&
    <div className="col-12 my-2 text-start ">
                      <Button  btnType="submit" value={'حضور'} disabled={!selectList?.length} onClick={()=>sendAttendeesListAsync(true)} />  
              <Button  btnType="cancel" value={'عدم حضور'} disabled={!selectList?.length} onClick={()=>sendAttendeesListAsync(false)} />
            
    
</div>}
            </div>
        </>

    );
}